const id_master_convertion = {
    "": "konversi barang",
    add: "tambah konversi barang",
    convertion_goods: "barang konversi",
    edit: "ubah konversi barang",
    goods: "konversi barang",
    name: "nama konversi",
    origin_goods: "barang asal",

    error: {
        convertion_goods: "Barang konversi tidak boleh kosong.",
        convertion_goods_qty: "Jumlah barang konversi tidak boleh kosong.",
        create: "Gagal membuat konversi.",
        delete: "Gagal menghapus konversi.",
        edit: "Gagal mengubah konversi.",
        name: "Nama konversi tidak boleh kosong.",
        origin_goods: "Barang asal tidak boleh kosong.",
        origin_goods_qty: "Jumlah barang asal tidak boleh kosong.",
    },

    success: {
        create: "Berhasil membuat konversi.",
        delete: "Berhasil menghapus konversi.",
        edit: "Berhasil mengubah konversi.",
    }
}

export default id_master_convertion;